import { useUnit } from 'effector-react'
import { memo, useEffect, type JSX } from 'react'
import { dynamicModuleModel } from '~/widgets/DynamicModule'
import { useInView } from 'react-intersection-observer'

export const LoadMoreRowsTrigger = memo(LoadMoreRowsTrigger_)

LoadMoreRowsTrigger_.displayName = 'LoadMoreRowsTrigger'
function LoadMoreRowsTrigger_(): JSX.Element {
  const [isLoaded, loadMoreCurrentRows] = useUnit([
    dynamicModuleModel.$isRowsLoaded,
    dynamicModuleModel.loadMoreCurrentRows,
  ])

  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && !isLoaded) {
      loadMoreCurrentRows()
    }
  }, [inView, isLoaded, loadMoreCurrentRows])

  return <div ref={ref} />
}
